import { useEffect, useState } from "react";
import { fetchIpCoords, watchLiveGps, type Coords } from "../../../shared/geo";

export function useLiveLocation(opts: { allowIpFallback?: boolean } = {}) {
  const [coords, setCoords] = useState<Coords | null>(null);
  const [error, setError] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let ipTimer: ReturnType<typeof setTimeout> | null = null;
    const handle = watchLiveGps(
      (next) => {
        if (cancelled) return;
        setCoords(next);
        setError("");
        setReady(true);
      },
      (message) => {
        if (cancelled) return;
        setError(message);
        setReady(true);
      },
    );
    if (opts.allowIpFallback) {
      ipTimer = setTimeout(() => {
        if (cancelled) return;
        void fetchIpCoords().then((ip) => {
          if (cancelled || !ip) return;
          setCoords((prev) => prev ?? ip);
          setReady(true);
        });
      }, 7000);
    }
    const readyTimer = setTimeout(() => {
      if (!cancelled) setReady(true);
    }, 12000);
    return () => {
      cancelled = true;
      handle.stop();
      if (ipTimer) clearTimeout(ipTimer);
      clearTimeout(readyTimer);
    };
  }, [opts.allowIpFallback]);

  return { coords, error, ready };
}
